module.exports = __webpack_public_path__ + "static/media/tisstiss.9fb0624b.svg";